import React from "react";
import { Box, Typography, Container, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <Box component="footer" sx={{ py: 3, mt: "auto", bgcolor: "primary.main", color: "white" }}>
      <Container maxWidth="lg" sx={{ textAlign: "center" }}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          © {new Date().getFullYear()} Gerenciador de Senhas Fidelius. Todos os direitos reservados.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <MuiLink component={Link} to="/about" color="inherit" underline="hover">
            Sobre Nós
          </MuiLink>
          <MuiLink component={Link} to="/terms" color="inherit" underline="hover">
            Termos de Uso
          </MuiLink>
          <MuiLink component={Link} to="/contact" color="inherit" underline="hover">
            Fale Conosco
          </MuiLink>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
